import React from 'react';
import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { SysMaintainFilled } from '@assets';
import { useSelector } from 'react-redux';

const SysMaintain = () => {
    const { t } = useTranslation();
    const { maintain_message } = useSelector(state => state.app);

    return (
        <Result
            title={t("sysmaintain.title")}
            subTitle={maintain_message}
            icon={<SysMaintainFilled />}
            extra={
                <Button
                    type="primary"
                    onClick={() => window.location.reload()}
                >
                    {t("error.retry")}
                </Button>
            }
        />
    );
}

export default SysMaintain;